import { useState } from "react";

const faqs = [
  {
    q: "Quel est le délai d'intervention à Créteil ?",
    a: "Securycles intervient en moyenne en 20 minutes à Créteil et dans le Val-de-Marne, 24h/24 et 7j/7, week-ends et jours fériés inclus.",
  },
  {
    q: "Ouvrez-vous une porte sans l'abîmer ?",
    a: "Oui, notre serrurier utilise des techniques d'ouverture non destructives. Dans la grande majorité des cas, la serrure et la porte sont préservées.",
  },
  {
    q: "Intervenez-vous pour les voitures ?",
    a: "Oui, nous ouvrons votre véhicule en cas de clés enfermées ou perdues, sans dégradation, toutes marques confondues.",
  },
  {
    q: "Proposez-vous des serrures connectées ?",
    a: "Oui, nous installons et configurons des serrures connectées (Nuki, Yale, Somfy) pour sécuriser votre domicile intelligemment.",
  },
  {
    q: "Le devis est-il gratuit ?",
    a: "Le devis par téléphone est entièrement gratuit et sans engagement. Nous vous donnons une estimation claire avant toute intervention.",
  },
  {
    q: "Couvrez-vous tout le Val-de-Marne ?",
    a: "Oui, Securycles intervient dans toutes les communes du 94 : Créteil, Vitry-sur-Seine, Saint-Maur, Champigny, Ivry, Maisons-Alfort et bien d'autres.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 md:py-20 bg-white">
      <div className="max-w-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-black text-black uppercase mb-1">
            Questions fréquentes
          </h2>
          <p className="text-gray-400 text-sm">Tout ce que vous devez savoir</p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-gray-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="font-bold text-black text-sm">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-[#FFB100] text-base transition-transform duration-200 ${
                      open === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 pb-4">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Schema.org FAQPage inline */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}
